import React from 'react';
import { Base, Colors, Row } from 'src/common';
import { DeliveryOptions } from 'src/features/common/types/application/delivery-options';
import styled from 'styled-components';

interface IThumb {
  active: boolean;
  disabled: boolean;
}

interface IDeliveryToggle {
  rightLabel: string;
  leftLabel: string;
  value: string;
  values: string[];
  onChange: Function;
}

const Thumb = styled(Base)<IThumb>`
  background-color: ${({ active }) => (active ? Colors.StrongYellow : Colors.White)};
  padding: 3px 10px;
  border-radius: 70px;
  color: ${({ active }) => (active ? Colors.White : Colors.Black)};
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    `
      color: ${Colors.BlueGray1};
      cursor: not-allowed;
  `}
`;

export const DeliveryToggle = (props: IDeliveryToggle) => {
  return (
    <Row backgroundColor={Colors.White} gap="18px" padding="3px" borderRadius="70px">
      <Thumb
        disabled={false}
        active={props.value.toLowerCase() === DeliveryOptions.Stock.toLowerCase()}
        onClick={() => props.onChange(DeliveryOptions.Stock)}
      >
        {props.leftLabel}
      </Thumb>
      <Thumb
        disabled={false}
        active={props.value.toLowerCase() === DeliveryOptions.Deliver.toLowerCase()}
        onClick={() => props.onChange(DeliveryOptions.Deliver)}
      >
        {props.rightLabel}
      </Thumb>
    </Row>
  );
};
